function addSocialLinksListener() {
    const socialLinks = document.querySelectorAll('[class*="#social-profiles-item"]');
    
    // Add click event listener to each link
    socialLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            // Get the href attribute
            const href = link.getAttribute('href');
            
            // Create URL object to easily parse the hostname
            const url = new URL(href);
            
            // Extract hostname and remove 'www.' if present
            const hostname = url.hostname.replace('www.', '');
            
            // Get the website name by splitting at the first dot
            const websiteName = hostname.split('.')[0];
            
            Shopify.analytics.publish("social_link_clicked", {website: websiteName});
        });
    });
}

document.addEventListener('DOMContentLoaded', addSocialLinksListener);